"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Slider = _interopRequireDefault(require("@mui/material/Slider"));
var _Text = _interopRequireDefault(require("./Text"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _theme = require("../theme");
var _system = require("@mui/system");
/**
 * @param value
 * @param onChange
 * @param onBlur
 * @param min
 * @param max
 * @param step
 * @param disabled
 * @param hideLabels
 * @returns {JSX.Element}
 * @constructor
 */
var Slider = function Slider(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    disabled = _ref.disabled,
    hideLabels = _ref.hideLabels;
  var theme = (0, _system.useTheme)();
  var style = {
    "&": {
      color: _theme.colors.lightGrey,
      height: 5
    },
    "& .MuiSlider-thumbColorPrimary": {
      height: 30,
      width: 30,
      backgroundColor: "#fff",
      border: "1px solid ".concat(_theme.colors.mediumLightGrey)
    },
    "& .MuiSlider-thumb.Mui-focusVisible": {
      boxShadow: "none !important"
    },
    "& .MuiSlider-thumb:hover": {
      boxShadow: "none !important"
    },
    "& .MuiSlider-thumb:active": {
      boxShadow: "none !important"
    },
    "& .Mui-active": {
      boxShadow: "none !important"
    },
    "& .MuiSlider-track": {
      height: "8px",
      borderWidth: 0,
      borderRadius: 10,
      color: theme.palette.primary.main
    },
    "& .MuiSlider-rail": {
      height: "8px",
      borderWidth: 0,
      borderRadius: 10,
      opacity: 1
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: 1
    }
  }, !hideLabels && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginBottom: 5
    }
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, _sbUtils.helpers.formatNumber(min, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true
  }, _sbUtils.helpers.formatNumber(max, 2, true))), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    sx: style,
    value: value,
    step: step || 1,
    marks: false,
    min: min,
    max: max
    // eslint-disable-next-line no-shadow
    ,
    onChange: !onChange ? null : function (e, value) {
      return onChange(value);
    },
    onChangeCommitted: !onBlur ? null : function (e, value) {
      return onBlur(value);
    },
    disabled: disabled || false
  }));
};
var _default = exports["default"] = Slider;